import {useContext} from 'react';
import { ProjectComponent } from "../components/Project/projectComponent";
import {AuthContext} from '../contexts/authContext';
import {db} from '../config/firebase';
import {collection, getDocs, query, where} from 'firebase/firestore';
import {useQuery} from '@tanstack/react-query';
import {LoadingCircle} from '../components/loading';

export const ProjectPrivate = () => {
    const { user } = useContext(AuthContext);

    const { data: uData, isDataLoading, isDataError } = useQuery({
        queryKey: ["loadprofile"], queryFn: async () => {
            const q = query(collection(db, "user"), where("owner", "==", user.uid));
            const data = await getDocs(q)
            
            const filteredData = data.docs.map((doc) => ({
                ...doc.data(),
            }));

            return filteredData[0];
        }
    });
    
    if (!isDataLoading && !isDataError) {
    return (
        <ProjectComponent isPublic="0" user={user} userData={uData}/>
    );
}
else{
    <LoadingCircle></LoadingCircle>
}
};